import React, { FC } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { ScheduledEventForm } from '../models/ScheduledEventDto';
import ScheduledEventFormGeneralFields from './ScheduledEventFormGeneralFields';
import ScheduledEventFormScheduledRelayFields from './ScheduledEventFormScheduledRelayFields';

const ScheduledEventFormFieldsMapper: FC<ScheduledEventFormFieldsMapperProps> = ({
  form,
}: ScheduledEventFormFieldsMapperProps) => {
  const { watch } = form;
  const eventType = watch('event.@type');

  switch (eventType) {
    case 'AUTO_RELAY_SWITCH':
    case 'MODBUS_READ_REGISTER':
    case 'MODBUS_WRITE_COIL':
    case 'MODBUS_READ_COIL':
    case 'RELAY_SWITCH':
    case 'SEND_DATE_OVER_MQTT':
    case 'SINGLE_RELAY_SWITCH':
    case 'TASMOTA_POWER':
      return <ScheduledEventFormGeneralFields form={form} />;
    case 'SCHEDULED_RELAY_COMMAND':
    case 'SCHEDULED_RELAY_COMMAND_4':
      return <ScheduledEventFormScheduledRelayFields form={form} />;
  }
};

interface ScheduledEventFormFieldsMapperProps {
  form: UseFormReturn<ScheduledEventForm, unknown, undefined>;
}

export default ScheduledEventFormFieldsMapper;
